module.exports = __webpack_public_path__ + "static/media/fullssg.c57e70b6.png";